<template>
  <ContentWrap>
    <el-form
      ref="queryFormRef"
      :inline="true"
      :model="queryParams"
      class="-mb-15px"
      label-width="68px"
    >
      <el-form-item label="店铺" prop="shopId">
        <el-select v-model="queryParams.shopId" placeholder="请选择店铺" clearable filterable class="!w-240px" @change="handleQuery">
          <el-option v-for="item in shopList" :key="item.id" :label="item.name" :value="item.id" />
        </el-select>
      </el-form-item>
      <el-form-item label="统计日期" prop="statDate">
        <el-date-picker
          v-model="queryParams.statDate"
          type="date"
          value-format="YYYY-MM-DD"
          placeholder="请选择统计日期"
          class="!w-240px"
        />
      </el-form-item>
      <el-form-item>
        <el-button @click="handleQuery">
          <Icon class="mr-5px" icon="ep:search" />
          搜索
        </el-button>
        <el-button @click="resetQuery">
          <Icon class="mr-5px" icon="ep:refresh" />
          重置
        </el-button>
        <el-button
          v-hasPermi="['hotel:statistics:create']"
          plain
          type="primary"
          @click="openForm('create')"
        >
          <Icon class="mr-5px" icon="ep:plus" />
          新增
        </el-button>
      </el-form-item>
    </el-form>
  </ContentWrap>

  <ContentWrap>
    <el-table v-loading="loading" :data="list">
      <el-table-column align="center" label="统计日期" prop="statDate" min-width="120" />
      <el-table-column align="center" label="总房间数" prop="totalRooms" min-width="80" />
      <el-table-column align="center" label="已入住房" prop="occupiedRooms" min-width="80" />
      <el-table-column align="center" label="可用房" prop="availableRooms" min-width="80" />
      <el-table-column align="center" label="入住数" prop="checkInCount" min-width="80" />
      <el-table-column align="center" label="退房数" prop="checkOutCount" min-width="80" />
      <el-table-column align="center" label="当前在住" prop="currentOccupancy" min-width="80" />
      <el-table-column align="center" label="新预订" prop="newBookingCount" min-width="80" />
      <el-table-column align="center" label="取消数" prop="cancelCount" min-width="80" />
      <el-table-column align="center" label="收入" prop="revenue" min-width="100">
        <template #default="scope">
          {{ scope.row.revenue != null ? '￥' + scope.row.revenue : '-' }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="入住率" prop="occupancyRate" min-width="100">
        <template #default="scope">
          {{ scope.row.occupancyRate != null ? scope.row.occupancyRate + '%' : '-' }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="清洁数" prop="cleaningCount" min-width="80" />
      <el-table-column align="center" label="维修数" prop="maintenanceCount" min-width="80" />
      <el-table-column align="center" label="报警数" prop="alertCount" min-width="80" />
      <el-table-column
        :formatter="dateFormatter"
        align="center"
        label="创建时间"
        prop="createTime"
        width="180"
      />
      <el-table-column align="center" label="操作" width="150" fixed="right">
        <template #default="scope">
          <el-button
            v-hasPermi="['hotel:statistics:update']"
            link
            type="primary"
            @click="openForm('update', scope.row.id)"
          >
            修改
          </el-button>
          <el-button
            v-hasPermi="['hotel:statistics:delete']"
            link
            type="danger"
            @click="handleDelete(scope.row.id)"
          >
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <Pagination
      v-model:limit="queryParams.pageSize"
      v-model:page="queryParams.pageNo"
      :total="total"
      @pagination="getList"
    />
  </ContentWrap>

  <Dialog v-model="dialogVisible" :title="dialogTitle">
    <el-form
      ref="formRef"
      v-loading="formLoading"
      :model="formData"
      :rules="formRules"
      label-width="100px"
    >
      <el-form-item label="店铺" prop="shopId">
        <el-select v-model="formData.shopId" placeholder="请选择店铺" clearable filterable class="!w-240px">
          <el-option v-for="item in shopList" :key="item.id" :label="item.name" :value="item.id" />
        </el-select>
      </el-form-item>
      <el-form-item label="统计日期" prop="statDate">
        <el-date-picker
          v-model="formData.statDate"
          type="date"
          value-format="YYYY-MM-DD"
          placeholder="请选择统计日期"
          class="!w-240px"
        />
      </el-form-item>
      <el-form-item label="总房间数" prop="totalRooms">
        <el-input-number v-model="formData.totalRooms" :min="0" class="!w-240px" />
      </el-form-item>
      <el-form-item label="已入住房" prop="occupiedRooms">
        <el-input-number v-model="formData.occupiedRooms" :min="0" class="!w-240px" />
      </el-form-item>
      <el-form-item label="可用房" prop="availableRooms">
        <el-input-number v-model="formData.availableRooms" :min="0" class="!w-240px" />
      </el-form-item>
      <el-form-item label="入住数" prop="checkInCount">
        <el-input-number v-model="formData.checkInCount" :min="0" class="!w-240px" />
      </el-form-item>
      <el-form-item label="退房数" prop="checkOutCount">
        <el-input-number v-model="formData.checkOutCount" :min="0" class="!w-240px" />
      </el-form-item>
      <el-form-item label="当前在住" prop="currentOccupancy">
        <el-input-number v-model="formData.currentOccupancy" :min="0" class="!w-240px" />
      </el-form-item>
      <el-form-item label="新预订数" prop="newBookingCount">
        <el-input-number v-model="formData.newBookingCount" :min="0" class="!w-240px" />
      </el-form-item>
      <el-form-item label="取消数" prop="cancelCount">
        <el-input-number v-model="formData.cancelCount" :min="0" class="!w-240px" />
      </el-form-item>
      <el-form-item label="收入" prop="revenue">
        <el-input-number v-model="formData.revenue" :min="0" :precision="2" class="!w-240px" />
      </el-form-item>
      <el-form-item label="入住率(%)" prop="occupancyRate">
        <el-input-number v-model="formData.occupancyRate" :min="0" :max="100" :precision="2" class="!w-240px" />
      </el-form-item>
      <el-form-item label="清洁数" prop="cleaningCount">
        <el-input-number v-model="formData.cleaningCount" :min="0" class="!w-240px" />
      </el-form-item>
      <el-form-item label="维修数" prop="maintenanceCount">
        <el-input-number v-model="formData.maintenanceCount" :min="0" class="!w-240px" />
      </el-form-item>
      <el-form-item label="报警数" prop="alertCount">
        <el-input-number v-model="formData.alertCount" :min="0" class="!w-240px" />
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input
          v-model="formData.remark"
          :rows="3"
          placeholder="请输入备注"
          type="textarea"
        />
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button :loading="formLoading" type="primary" @click="submitForm">确 定</el-button>
      <el-button @click="dialogVisible = false">取 消</el-button>
    </template>
  </Dialog>
</template>

<script lang="ts" setup>
import { dateFormatter } from '@/utils/formatTime'
import * as StatisticsApi from '@/api/hotel/statistics'
import { getShopSimpleList } from '@/api/hotel/platformShop'

defineOptions({ name: 'HotelStatistics' })

const message = useMessage()
const { t } = useI18n()

const loading = ref(true)
const total = ref(0)
const list = ref([])

// 店铺下拉列表
const shopList = ref<any[]>([])
const getShopList = async () => {
  const data = await getShopSimpleList()
  shopList.value = data || []
}

const queryParams = reactive<any>({
  pageNo: 1,
  pageSize: 20,
  statDate: undefined,
  shopId: undefined
})
const queryFormRef = ref()

const getList = async () => {
  loading.value = true
  try {
    const data = await StatisticsApi.getStatisticsPage(queryParams)
    list.value = data.list
    total.value = data.total
  } finally {
    loading.value = false
  }
}

const handleQuery = () => {
  queryParams.pageNo = 1
  getList()
}

const resetQuery = () => {
  queryFormRef.value.resetFields()
  handleQuery()
}

const dialogVisible = ref(false)
const dialogTitle = ref('')
const formLoading = ref(false)
const formType = ref('')
const formData = ref<StatisticsApi.StatisticsVO>({
  id: undefined,
  shopId: undefined,
  statDate: '',
  totalRooms: 0,
  occupiedRooms: 0,
  availableRooms: 0,
  checkInCount: 0,
  checkOutCount: 0,
  currentOccupancy: 0,
  newBookingCount: 0,
  cancelCount: 0,
  revenue: 0,
  occupancyRate: 0,
  cleaningCount: 0,
  maintenanceCount: 0,
  alertCount: 0,
  remark: '',
  createTime: undefined as any
})
const formRules = reactive({
  shopId: [{ required: true, message: '店铺不能为空', trigger: 'change' }],
  statDate: [{ required: true, message: '统计日期不能为空', trigger: 'change' }]
})
const formRef = ref()

const openForm = async (type: string, id?: string | number) => {
  dialogVisible.value = true
  dialogTitle.value = t('action.' + type)
  formType.value = type
  resetForm()
  if (id) {
    formLoading.value = true
    try {
      formData.value = await StatisticsApi.getStatistics(id)
    } finally {
      formLoading.value = false
    }
  }
}

const submitForm = async () => {
  if (!formRef) return
  const valid = await formRef.value.validate()
  if (!valid) return
  formLoading.value = true
  try {
    const data = formData.value
    if (formType.value === 'create') {
      await StatisticsApi.createStatistics(data)
      message.success(t('common.createSuccess'))
    } else {
      await StatisticsApi.updateStatistics(data)
      message.success(t('common.updateSuccess'))
    }
    dialogVisible.value = false
    await getList()
  } finally {
    formLoading.value = false
  }
}

const resetForm = () => {
  formData.value = {
    id: undefined,
    shopId: 0,
    statDate: '',
    totalRooms: 0,
    occupiedRooms: 0,
    availableRooms: 0,
    checkInCount: 0,
    checkOutCount: 0,
    currentOccupancy: 0,
    newBookingCount: 0,
    cancelCount: 0,
    revenue: 0,
    occupancyRate: 0,
    cleaningCount: 0,
    maintenanceCount: 0,
    alertCount: 0,
    remark: '',
    createTime: undefined as any
  }
  formRef.value?.resetFields()
}

const handleDelete = async (id: string | number) => {
  try {
    await message.delConfirm()
    await StatisticsApi.deleteStatistics(id)
    message.success(t('common.delSuccess'))
    await getList()
  } catch {}
}

onMounted(() => {
  getList()
  getShopList()
})
</script>
